export function TypingDots() {
  return (
    <span className="typing" aria-label="assistant is typing">
      <span />
      <span />
      <span />
    </span>
  );
}
